import { RegExpUtility } from '../text/RegExpUtility';

export function addClass( element:Element, classString:string )
{
  let classAttribute = element.getAttribute( "class" ) || "";
  let matcher = RegExpUtility.createWordMatcher( classString );

  if ( matcher.test( classAttribute ) )
  {
    return;
  }

  classAttribute += " " + classString;
  
  setNormalizedClassAttribute( element, classAttribute );
}

export function removeClass( element:Element, classString:string )
{
  let matcher = RegExpUtility.createWordMatcher( classString );
  let classAttribute = element.getAttribute( "class" ) || ""; 

  classAttribute = classAttribute.replace( matcher, "" );
  setNormalizedClassAttribute( element, classAttribute );
}

export function hasClass( element:Element, classString:string )
{
  let matcher = RegExpUtility.createWordMatcher( classString );
  let classAttribute = element.getAttribute( "class" ) || ""; 
  
  return matcher.test( classAttribute );
}

export function setNormalizedClassAttribute( element:Element, classAttribute:string )
{ 
  classAttribute = classAttribute.replace( /\s+/g, " " );
  classAttribute = classAttribute.trim();
  
  if ( "" === classAttribute )
  {
    element.removeAttribute( "class" );
  }
  else
  {
    element.setAttribute( "class", classAttribute );
  }
  
}

export function setClass( element:Element, classString:string, enable:boolean )
{
  if ( enable )
  {
    addClass( element, classString ); 
  }
  else
  {
    removeClass( element, classString );
  }
}

export function toggleClassState( element:Element, classString:string )
{
  let hasClassAssigned = hasClass( element, classString );

  setClass( element, classString, ! hasClassAssigned );
}